<template>
  <div>
    <ul class="d-flex flex-wrap text-center p-0">
      <ItemViewTemplate
        :item="template"
        v-for="(template, index) in handleTemplates"
        :key="index"
      />
    </ul>
  </div>
</template>

<script>
import ItemViewTemplate from './ItemViewTemplate'

export default {
  name: "ListViewtemplate",
  components: {
    ItemViewTemplate
  },
  props: {
    templates: {
      type : Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    handleTemplates() {
      return this.templates.map(item => {
        return({
          ...item,
           alwaysVisible: item.alwaysVisible == false ? false : true
        })
      })
    }
  }
}
</script>

<style>

</style>
